<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="list-margin">
    <DataTable
      :value="eventlist"
      class="p-datatable-lg p-datatable-customers"
      dataKey="id"
      :rowHover="true"
      :resizableColumns="false"
      v-model:expandedRowGroups="expandedRowGroups"
      expandableRowGroups
      rowGroupMode="subheader"
      groupRowsBy="customername"
      sortField="customername"
      sortMode="single"
      :sortOrder="1"
    >
      <template #header>
        <div class="grid m-0">
          <div class="lg:col-4 col-12 lg:text-left text-center list-header">
            Event Report
          </div>

          <div
            class="lg:col-8 col-12 grid lg:justify-content-end justify-content-center m-0"
          >
            <Calendar
              v-model="dates"
              id="date"
              class="mr-2 col-12 lg:col-4 p-0"
              label="Date"
              showIcon
              selectionMode="range"
              :manualInput="false"
              placeholder="Enter Date"
              dateFormat="yy-mm-dd"
            />
            <Dropdown
              v-model="status"
              :options="statusoption"
              optionLabel="name"
              placeholder="Select a status"
              optionValue="name"
              label="Status"
              class="statusdropdown mt-2 lg:mt-0 lg:col-2"
            />
            <PrimeButton
              icon="pi pi-filter"
              class="btn-filter mt-2 lg:mt-0 lg:col-2"
              @click="getData"
            ></PrimeButton>
          </div>
        </div>
      </template>
      <template #loading> Loading records, please wait... </template>
      <template #empty> No records found. </template>
      <template #groupheader="slotProps">
        <span class="vertical-align-middle ml-2 font-bold line-height-3">{{
          slotProps.data.customername
        }}</span>
      </template>
      <Column field="eventname" header="Event Name">
        <template #body="row">
          <div class="flex">
            <span class="margin-username">{{ row.data.eventname }}</span>
          </div>
        </template>
      </Column>
      <Column field="customername" header="Customer">
        <template #body="row">
          <div class="flex">
            <span class="margin-username">{{ row.data.customername }}</span>
          </div>
        </template>
      </Column>
      <Column field="status" header="Status">
        <template #body="data">
          <Chip
            v-if="data.data.status == 'Confirm'"
            :label="data.data.status"
            class="chip-style-for-order-confirm"
          />
          <Chip
            v-if="data.data.status == 'Inquiry'"
            :label="data.data.status"
            class="chip-style-for-order-inquiry"
          />
          <Chip
            v-if="data.data.status == 'Cancel'"
            :label="data.data.status"
            class="chip-style-for-order-cancel"
          />
        </template>
      </Column>
      <Column
        field="eventdate"
        header="Date and Time"
        class="datetime"
      ></Column>
    </DataTable>
    <Paginator
      v-model:first="currentPage"
      :rows="50"
      :totalRecords="totalRecords"
      :rowsPerPageOptions="[50, 100, 150, 200]"
      template="RowsPerPageDropdown CurrentPageReport PageLinks"
      currentPageReportTemplate="{first} - {last} of {totalRecords} items"
      @page="onPage($event)"
      :class="{
        loading: loading,
      }"
    >
      <template #start> Shown per page : </template>
    </Paginator>
  </div>
</template>
<script>
import APIService from "@/services/api-service.js";
import EventFactory from "@/factories/event.js";
import DateFormat from "@/libs/DateFormat";
export default {
  data() {
    return {
      loading: false,
      minEventDate: new Date(),
      lastDate: new Date(),
      expandedRowGroups: null,
      statusoption: [
        { name: "All" },
        { name: "Inquiry" },
        { name: "Confirm" },
        { name: "Cancel" },
      ],
      eventlist: [],
      dates: null,
      status: "All",
      currentPage: 0,
      itemsPerPage: 50,
      totalRecords: 0,
    };
  },
  created() {
    let today = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      0,
      0
    );
    this.minEventDate = today;
    let todaydays = this.minEventDate.getDate();
    let minusdays = todaydays - 30;
    this.lastDate.setDate(minusdays);
    this.dates = [this.lastDate, this.minEventDate];
  },
  mounted() {
    this.getEventList();
  },
  methods: {
    getEventList() {
      this.$root.$globalState.loader = true;
      this.eventlist = [];

      let payload = {
        startdate: DateFormat.formatDate(this.dates[0]),
        enddate:
          this.dates[1] == null
            ? DateFormat.formatDate(this.dates[0])
            : DateFormat.formatDate(this.dates[1]),
        status: this.status,
      };
      APIService.post(
        `/event/eventlist/${this.currentPage}/${this.itemsPerPage}`,
        payload
      )
        .then((response) => {
          if (response && response.data) {
            this.totalRecords = response.data.totalrecord;
            this.eventlist = EventFactory.createFromJsonArray(
              response.data.data
            );
          }
        })
        .finally(() => {
          this.$root.$globalState.loader = false;
        });
    },
    onPage(pageData) {
      this.itemsPerPage = pageData.rows;
      this.currentPage = pageData.first;
      this.getEventList();
    },
    getData() {
      this.currentPage = 0;
      this.getEventList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/datatable.scss";
@media (min-width: 991.98px) AND (max-width: 1315.98px) {
  .template-view.expand .p-input-icon-right {
    margin-top: 12px;
  }
}
@media (min-width: 991.98px) AND (max-width: 1035.98px) {
  .template-view.not-expand .p-input-icon-right {
    margin-top: 12px;
  }
}
// @media (max-width: 445.98px) {
//   .add-button {
//     margin-right: 0 !important;
//   }
// }
@media (max-width: 991.98px) {
  .add-button {
    margin-right: 12px;
  }
  :deep(.statusdropdown.p-dropdown) {
    margin-right: 12px;
    width: 80% !important;
  }
}
@media (max-width: 474.98px) {
  :deep(.statusdropdown.p-dropdown) {
    margin-top: 12px;
    margin-right: 12px !important;
  }
  .btn-filter {
    margin-top: 12px;
  }
}
@media (max-width: 363.98px) {
  .btn-filter {
    margin-top: 12px;
    margin-right: 0 !important;
  }
  :deep(.statusdropdown.p-dropdown) {
    margin-top: 12px;
    margin-right: 12px !important;
  }
}
@media (max-width: 495.98px) {
  ::v-deep(.p-datatable.p-datatable-customers .add-button) {
    margin-bottom: 0px;
  }
}
.btn-filter {
  width: 120px;
  justify-content: center;
  align-items: center;
  padding: 12px 24px 12px 16px;
  height: 48px;
  background: #ff9f43;
  border-radius: 8px;
  border-color: #ff9f43;

  .btn-filter-label {
    height: 24px;

    font-family: OpenSans;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    text-transform: uppercase;
    letter-spacing: -0.02em;
    color: #ffffff;
    flex: none;
  }
}
.btn-filter:hover {
  background: #ff9f43 !important;
  border-radius: 8px;
  border-color: #ff9f43 !important;
}
:deep(.statusdropdown.p-dropdown) {
  margin-right: 12px;
  width: 120px;
}
::v-deep(.p-calendar-w-btn .p-inputtext) {
  height: inherit !important;
}
.margin-username {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
